import type { NexaLayout } from "./constants";

const RETURN_PATH_KEY = "nexa:return-path";
const PENDING_LAYOUT_KEY = "nexa:pending-layout";
const THREAD_KEY = "nexa:active-thread";

export const DEFAULT_RETURN_PATH = "/all-skus";

const read = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key: string, value: string | null) => {
  try {
    if (value === null) window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, value);
  } catch {
  }
};

const LAST_THREAD_KEY = "nexa:last-thread";

export const rememberThread = (threadId: string | null) => write(LAST_THREAD_KEY, threadId);

export const recallThread = (): string | null => read(LAST_THREAD_KEY) || null;

export const stashForFullscreen = (returnPath: string, threadId: string | null) => {
  write(RETURN_PATH_KEY, returnPath);
  write(THREAD_KEY, threadId);
};

export const stashForLauncher = (layout: Extract<NexaLayout, "floating" | "sidebar">, threadId: string | null) => {
  write(PENDING_LAYOUT_KEY, layout);
  write(THREAD_KEY, threadId);
};

export interface NexaHandoff {
  returnPath: string;
  threadId: string | null;
  pendingLayout: Extract<NexaLayout, "floating" | "sidebar"> | null;
}

export const peekHandoff = (): NexaHandoff => {
  const path = read(RETURN_PATH_KEY);
  const layout = read(PENDING_LAYOUT_KEY);
  return {
    returnPath: path && path.startsWith("/") && !path.startsWith("/nexa-ai") ? path : DEFAULT_RETURN_PATH,
    threadId: read(THREAD_KEY) || null,
    pendingLayout: layout === "floating" || layout === "sidebar" ? layout : null,
  };
};

export const clearHandoff = () => {
  write(RETURN_PATH_KEY, null);
  write(PENDING_LAYOUT_KEY, null);
  write(THREAD_KEY, null);
};
